module.exports = {"id":"158438","name":"Gelson Fernandes","rating":"76","photo":"./data/images/photos/1/158438.png","club":{"name":"Eint. Francfort","logo":"./data/images/clubs/Eint.Francfort.png"},"positions":["MDC","MC"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/GelsonFernandes0.json
// module id = 1547
// module chunks = 0